export const SITE_KEY = "6LfqGGQpAAAAADlXubOdcVnZrE-n9NhBXIIx1jg2";

export const SECRET = "6LfqGGQpAAAAAOttQu3Cp7RYnfhgK3HkcIV28AoF";